import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import Layout from '../components/Layout';
import { useOnboarding } from '../hooks/useOnboarding';
import { useSubscription } from '../hooks/useSubscription';
import { useAuth } from '../providers/AppAuthProvider';

import PaymentStatement from './StatementAnalyzer';

const HomePage: React.FC = () => {
	const { user } = useAuth();
	const { isComplete } = useOnboarding();
	const {
		subscriptionStatus,
		isLoading: subscriptionLoading,
		shouldShowOnboarding,
		onboardingCompleted,
	} = useSubscription();
	const navigate = useNavigate();

	const shouldRedirectToOnboarding =
		Boolean(user?.email) &&
		shouldShowOnboarding &&
		!onboardingCompleted &&
		!isComplete;

	useEffect(() => {
		if (shouldRedirectToOnboarding) {
			navigate('/onboarding', { replace: true });
		}
	}, [shouldRedirectToOnboarding, navigate]);

	// Don't redirect while loading subscription data
	if (subscriptionLoading || !subscriptionStatus) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<div className="text-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
					<p className="text-gray-600">Loading...</p>
				</div>
			</div>
		);
	}

	// If redirecting, show loading
	if (shouldRedirectToOnboarding) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<div className="text-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
					<p className="text-gray-600">Redirecting to onboarding...</p>
				</div>
			</div>
		);
	}

	// If onboarding is complete or user is not first-time, show the main app
	return (
		<Layout>
			<PaymentStatement mfe={false} />
		</Layout>
	);
};

export default HomePage;
